<template>
  <div>
    <NBar title="卡项设置" :top="true"/>
    <div class="item">
      <nut-textinput v-model="form.name" label="名称：" placeholder="请输入名称"
                     :has-border="false" :clearBtn="false" :disabled="false" class="input"/>
    </div>
    <div class="item">
      <nut-textinput v-model="form.price" label="金额：" placeholder="请输入金额"
                     :has-border="false" :clearBtn="false" :disabled="false" class="input"/>
    </div>
    <div class="item">
      <nut-textinput v-model="form.time" label="限制时间：" placeholder="请输入时间(单位:天)"
                     :has-border="false" :clearBtn="false" :disabled="false" class="input"/>
    </div>
    <nut-cell :show-icon="true" style="margin-bottom: 10px;" @click.native="showService = true">
      <span slot="title">限制项目</span>
      <span slot="desc">{{ serviceNames != null && serviceNames != '' ? serviceNames : '未设置' }}</span>
    </nut-cell>
    <!--选择限制服务-->
    <nut-popup v-model="showService" position="bottom" closeable :style="{height: '300px'}">
      <nut-cell style="margin-top: -3px;">
        <span slot="title" style="font-size: 16px;">选择限制项目</span>
      </nut-cell>
      <nut-scroller style="height:calc(100% - 90px);" type="vertical" :is-loading="isServiceLoading"
                    @pulldown="serviceDownClick">
        <div slot="list">
          <nut-cell v-for="(item ,index) in serviceList" :key="index">
            <span slot="title">{{ item.name }}</span>
            <span slot="desc">
                <nut-checkbox v-model="item.checked" @change="selectService($event,item,index)"/>
              </span>
          </nut-cell>
        </div>
      </nut-scroller>
      <div class="bottom">
        <nut-checkbox v-model='isServiceAll' @change="checkDeviceTypeAll" class="bottom-checkbox">全选</nut-checkbox>
        <nut-button class="btn" small @click.native="confirm">确定({{ selectServiceList.length }})
        </nut-button>
      </div>
    </nut-popup>
    <div class="item">
      <nut-textinput v-model="form.restrictNum" label="限制次数：" placeholder="请输入限制次数(单位:天)"
                     :has-border="false" :clearBtn="false" :disabled="false" class="input"/>
    </div>
    <nut-button style="margin: 30px 15px;border-radius: 5px;width:92%;" @click.native="save">保存</nut-button>
  </div>
</template>

<script>
export default {
  name: 'CardSet',
  props: ['data'],
  data () {
    return {
      form: {
        id: null,
        name: null,
        price: 0,
        time: null,
        serviceIds: '',
        restrictNum: null,
        serviceNames: '',
      },
      showService: false,
      isServiceLoading: false,
      isServiceAll: false,
      serviceList: [],
      selectServiceList: [],
      serviceNames: '',
    }
  },
  mounted () {
    if (!this.$util.isArrOrNull(this.data)) {
      let data = JSON.parse(decodeURIComponent(this.data))
      this.$util.ofData(this.form, data)
      this.serviceNames = this.form.serviceNames
    }
    this.getServiceList()
  },
  methods: {
    save () {
      //处理选中的地址
      let serviceIds = ''
      this.selectServiceList.forEach(item => {
        serviceIds += item.id + ';'
      })
      this.form.serviceIds = serviceIds.substring(0, serviceIds.length - 1)
      this.$api.post({
        url: '/device/api/device/device-card/save',
        data: this.form,
      }).then(() => {
        setTimeout(() => {
          this.$router.go(-1)
        }, 1500)
      })
    },
    getServiceList () {
      this.$api.post({
        url: '/device/api/device/device-service/list',
        data: {
          isTest: 0,
        }
      }).then(res => {
        this.serviceList = res.data
        let serviceIds = this.form.serviceIds.split(',')
        serviceIds.forEach(item => {
          this.serviceList.forEach(service => {
            if (item == service.id) {
              service.checked = true
            }
          })
        })
        this.isServiceLoading = false
      })
    },
    serviceDownClick () {
      this.isServiceLoading = true
      this.getServiceList()
    },
    selectService (val, item, index) {
      if (val) {
        this.selectServiceList.push({
          id: item.id,
          name: item.name
        })
      } else {
        this.selectServiceList.splice(index, 1)
      }
    },
    checkDeviceTypeAll () {
      let i
      let list = this.serviceList
      if (!this.isAll) {
        for (i in list) {
          list[i].checked = false
          this.selectServiceList = []
        }
      } else {
        for (i in list) {
          list[i].checked = true
          this.selectServiceList.push({
            id: list[i].id,
            name: list[i].name
          })
        }
      }
    },
    confirm () {
      let serviceNames = ''
      this.selectServiceList.forEach(item => {
        serviceNames += item.name + ','
      })
      this.serviceNames = serviceNames.substring(0, serviceNames.length - 1)
      this.showService = false
    },
  }
}
</script>

<style scoped>
.item {
  padding: 10px;
  background-color: #fff;
}

.bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 45px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bottom-checkbox {
  flex: 0.8;
  text-align: center;
}

.bottom .btn {
  flex: 1;
  border-radius: 0;
  height: 45px;
}

>>> .nut-button {
  background: #409EFF;
}

>>> .nut-checkbox input:checked {
  background-color: #409EFF;
  border-color: #409EFF;
  border-radius: 50%;
}

>>> .nut-checkbox.nut-checkbox-size-base input {
  border-radius: 50%;
}

>>> .nut-checkbox input:after {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/CardSet.vue